<template>
  <NetworkFeed :unlisted="false" />
</template>
<script>
import NetworkFeed from '@/views/networks/media/feed/index.vue';

export default {
  name: 'NetworkHome',
  components: {
    NetworkFeed,
  },
};
</script>
